<template>
  <div class="demo-container">
		<bg-wave-element class="mobile-hide"></bg-wave-element>
		<section class="demo-inner">
			<h3>Empower your people to change the world.</h3>
			<button @click="$router.push('/book-a-demo')">book a demo</button>
		</section>
		<section class="join-us">
			<div class="join-us-inner flex-row breakdown template-inner">
				<img class="one-quarter" src="@/assets/img/icons/partners-footer-circle.png" alt="">
				<div class="join-us-content one-half">
					<h4>We’re growing fast. Want to join{{'\xa0'}}us?</h4>
					<p>Become an authorized Evergrow reseller and earn rewards for helping us engage more companies and plant millions more trees.</p>
				</div>
				<div class="text-center">
					<button @click="$router.push('/partners')">partner&nbsp;with&nbsp;us</button>
				</div>
			</div>
		</section>
  </div>
</template>

<script>
	export default {
    name: 'Demo'
  }
</script>

<style lang="stylus" scoped>
	.demo-inner
		text-align center
		margin-top -10px
		background-color #00A562
		padding 40px 0 130px 
		
		h3
			font-family baskerville-urw, serif
			font-weight 100
			color white
			font-size 50px
			margin-bottom 40px

	.demo-inner button 
		background #FF8D03
		color white
		border 1px solid #FF8D03

		&:hover 
			background white
			color #FF8D03
			border 1px solid #FF8D03

  //join us 
	.join-us 
		background-color #F0F0E4
		padding 90px 0
		
		h4 
			font-size 24px
			margin-bottom 25px

	.join-us-inner
		align-items center
		margin 0 auto 
		text-align  left

		img
			width 100%
			max-width 200px
			border-radius 100%
			box-shadow: 0px 20px 40px rgba(0,0,0,0.2);

	.blog-post-container .demo-container svg
		background-color #F0F0E4 !important
    
	@media (max-width: 1000px)
		.demo-inner 
			padding 60px 
			
			h3
				font-size 36px
		
		.join-us
			// padding 60px
				
		.join-us-inner img.one-quarter
			width 100% !important
			margin-bottom 40px
			
		.join-us-content
			text-align center
			
			h4
				font-size 20px
			
			p
				font-size 14px
				margin-bottom 20px
</style>